import { defineStore } from "pinia";
import { POS_INFORMATION, POS_BOOKING_INFORMATION } from "@/shared/resource/constants";
import { api } from "@/shared/resource/apis/baseApi";
import { POS } from "@/shared/resource/apis/endpoints";
import { dateTime } from "@/shared/utills/date";

export const usePosStore = defineStore("pos", {
  state: () => ({
    posList: {
      list: [],
      totalCount: 0,
      info: [...POS_INFORMATION],
    },
    posBookings: {
      list: [],
      info: [...POS_BOOKING_INFORMATION],
      totalCount: 0,
    },
  }),

  actions: {
    clearPosBookings() {
      this.posBookings.list = [];
      this.posBookings.info = [...POS_BOOKING_INFORMATION];
      this.posBookings.totalCount = 0;
    },
    clearPosList() {
      this.posList.list = [];
      this.posList.totalCount = 0;
      this.posList.info = [...POS_INFORMATION];
    },
    async fetchPos({ page = 1, limit = 10, filters = {} } = {}) {
      this.clearPosList();

      const response = await api.get(POS.GET, { params: { page, limit, ...filters }});
      const data = response?.data?.data || [];

      const formattedEntities = data.map((pos) => ({
        id: pos.bus_id,
        busNo: pos.bus_no,
        createdAt: dateTime.formatUstTimeStamps(pos.created_at),
        deviceId: pos.device_id,
        lastSyncTime: pos.last_sync_timestamp,
        onlineBookings: pos.online_bookings,
        posBookings: pos.pos_bookings,
        revenue: pos.revenue,
        totalTrips: pos.total_trips,
        status: pos.status === "INACTIVE" ? false : true,
      }));

      this.setPosList(formattedEntities, response.data.pagination.total || 0, response.data.summary || []);
      return formattedEntities;
    },
    async getPosBookingListById({ id, page = 1, limit = 10, filters = {}} = {}) {
      this.clearPosBookings();

      const response = await api.get(POS.GET_BY_BUS, { params: { bus_id: id, page: page, limit, ...filters }});
      const formattedData = response.data.data.map((booking) => ({
        id: booking.ticket_id,
        busId: booking.bus_id,
        busNo: booking.bus_no,
        createdAt: dateTime.formatUstTimeStamps(booking.booking_timestamp),
        bookingType: booking.source_type,
        deviceId: booking.device_id,
        passengers: booking.passengers,
        price: booking.total_price,
        payment: booking.payment,
      }));

      this.setPosBookings(formattedData, response.data.pagination.total || 0, response.data.summary || [], response?.data?.bus);
      return formattedData;
    },

    async getPosTicketDetails(ticketId) {
      const response = await api.get(POS.GET_TICKET_DETAILS(ticketId));
      return response.data.data;
    },
    setPosBookings(list, total = 0, info) {
      this.posBookings.list = list;
      this.posBookings.totalCount = total;
      if (info) {
        this.posBookings.info[0].count = info.tickets_issued || 0;
        this.posBookings.info[1].count = info.total_revenue || 0;
        this.posBookings.info[2].count = info.cash_collected || 0;
        this.posBookings.info[3].count = info.online_bookings || 0;
        this.posBookings.info[4].count = info.pos_bookings || 0;
      }
    },
    setPosList(list, total, info) {
      this.posList.list = list;
      this.posList.totalCount = total;
      if (info) {
        this.posList.info = this.posList.info.map((item) => ({
          ...item,
          previousMonthValue: info[item.key]?.previous_month_value || 0,
          currentMonthValue: info[item.key]?.current_month_value || 0,
          count: info[item.key]?.value || 0,
          percentage: info[item.key]?.change_percent || 0,
          trend: info[item.key]?.change_direction === "MORE" ? "up" : "down",
        }));
      }
    },
  },

  getters: {
    getPosList: (state) => state.posList,
    getPosBookings: (state) => state.posBookings,
  },
});